import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/admin/Layout.vue'),
    redirect: '/home',
    children: [
      { path: 'home', name: 'Home', component: () => import('@/views/admin/Home.vue') },
      { path: 'ownMerchant', name: 'OwnMerchant', component: () => import('@/views/merchants/ownMerchant.vue') },
      { path: 'platformMerchant', name: 'PlatformMerchant', component: () => import('@/views/merchants/platformMerchant.vue') },
      { path: 'selectedMerchant', name: 'SelectedMerchant', component: () => import('@/views/merchants/selectedMerchant.vue') },
      { path: 'writeOff', name: 'WriteOff', component: () => import('@/views/order/writeOff.vue') },
      { path: 'account', name: 'Account', component: () => import('@/views/account/index.vue') },
      { path: 'changePassword', redirect: '/user/profile' },
      { path: 'user/profile', name: 'UserProfile', component: () => import('@/views/system/user/profile/index.vue') },

      // 墨者管理
      { path: 'mozer/account', name: 'MozerAccount', component: () => import('@/views/mozer/account/index.vue') },
      { path: 'mozer/commission', name: 'MozerCommission', component: () => import('@/views/mozer/commission/index.vue') },

      // 团购管理
      { path: 'groupPurchase/goodsPackage', name: 'GoodsPackage', component: () => import('@/views/groupPurchase/goodsPackage/index.vue') },
      { path: 'groupPurchase/packageOrder', name: 'PackageOrder', component: () => import('@/views/groupPurchase/packageOrder/index.vue') },
      { path: 'groupPurchase/packageLabel', name: 'PackageLabel', component: () => import('@/views/groupPurchase/packageLabel/index.vue') },

      // 团购管理 - 隐藏页面（套餐添加/编辑/详情）
      { path: 'goodsPackage/add', name: 'GoodsPackageAdd', component: () => import('@/views/groupPurchase/goodsPackage/add.vue') },
      { path: 'goodsPackage/edit', name: 'GoodsPackageEdit', component: () => import('@/views/groupPurchase/goodsPackage/add.vue') },
      { path: 'goodsPackage/detail', name: 'GoodsPackageDetail', component: () => import('@/views/groupPurchase/goodsPackage/detail.vue') },

      // 彩票工具
      { path: 'lotteryTools/openMerchants', name: 'OpenMerchants', component: () => import('@/views/lotteryTools/openMerchants/index.vue') },
      { path: 'lotteryTools/giftRecord', name: 'GiftRecord', component: () => import('@/views/lotteryTools/giftRecord/index.vue') },
      { path: 'lotteryTools/ticketRecord', name: 'TicketRecord', component: () => import('@/views/lotteryTools/ticketRecord/index.vue') }
    ]
  },
  { path: '/login', component: () => import('@/views/Login.vue') }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 忽略重复/取消导航的错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled') throw err
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated' && err.name !== 'NavigationCancelled') throw err
  })
}

export default router
